require('../blockStep.scss');
require('./blockStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { nonNumericFilter } = require('utilities/stringHelper');
// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const {
    CARD_BLOCK_REQUEST_ID,
    CARD_REPLACE_ID,
    MULTIPLE_OPERATIONS,
    messages: {CODIGO_MESSAGE_2}
} = require('constants/operationTypes');

class BlockStep2 extends React.Component {

    buildConfirmationMessage() {
        const {
            cardId,
            cardReplace,
            immCards
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const cardNumber = immCard.get('number').substr(-4);
        let confirmationMessagePart1 = 'cardBlock-confirmationMessagePart1';
        let confirmationMessagePart2;

        if (immCard.get('isViaT')) {
            confirmationMessagePart1 += 'ViaT';
        }

        if (cardReplace) {
            confirmationMessagePart2 = (
                <FormattedText value="cardBlock-confirmationMessagePart2" />
            );
        }

        const operative = formatText('operatives-cardBlock');

        return (
            <section className="block-step__content">
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operative}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <FormattedText
                    injectedStrings={[cardNumber]}
                    value={confirmationMessagePart1}
                />
                {confirmationMessagePart2}
                <ContactCenterRender>
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                    />
                </ContactCenterRender>
            </section>
        );
    }

    buildSignaturePattern(){
        const {
            cardId,
            cardReplace,
            immCards
        } = this.props;
        let operationType = CARD_BLOCK_REQUEST_ID;
        let operationParams = {
            pan: nonNumericFilter(immCards.getIn(['byId', cardId, 'number']))
        };

        if (cardReplace) {
            operationType = MULTIPLE_OPERATIONS;
            operationParams = {
                requestMulti: [{
                    serviceCode: CARD_BLOCK_REQUEST_ID,
                    pan: nonNumericFilter(immCards.getIn(['byId', cardId, 'number']))
                },{
                    serviceCode: CARD_REPLACE_ID,
                    pan: nonNumericFilter(immCards.getIn(['byId', cardId, 'number']))
                }],
                id: CODIGO_MESSAGE_2,
            }
        }

        return (
            <section className="block-step__signature-pattern">
                <SignaturePattern
                    operationType={operationType}
                    operationParams={operationParams}
                />
            </section>
        );
    }

    render() {
        const confirmationMessageSection = this.buildConfirmationMessage();
        const signaturePatternSection = this.buildSignaturePattern();

        return (
            <article className="block-step block-step--two">
                <header className="block-step__header">
                    <FormattedText value="cardBlock-securityConfirmation" className="block-step__title" />
                </header>

                {confirmationMessageSection}
                {signaturePatternSection}
            </article>
        )
    }
}

BlockStep2.propTypes = {
    cardId: PropTypes.string,
    cardReplace: PropTypes.bool,
    immCards: PropTypes.object
};

module.exports = BlockStep2;
